let redirectingToLogoutOn401 = false

/** Shown on 401 before logout redirect. */
export const UNAUTHORIZED_SESSION_MESSAGE = "Please sign in again."

const LOGOUT_REDIRECT_DELAY_MS = 1200

const isAuthShellPath = () => {
    const path = window.location.pathname || ""
    return path === "/application/logout"
        || path === "/services/logout"
        || path === "/services/signin"
        || path.indexOf("/services/signin") === 0
}

export const isRedirectingToLogoutOnUnauthorized = () => redirectingToLogoutOn401

/**
 * Full borrower/loan delete leaves a live JWT but V2 APIs return 401
 * (loanIDfromID → no rows). Force logout instead of leaving a broken session.
 */
export const redirectToLogoutOnUnauthorized = () => {
    if (redirectingToLogoutOn401 || isAuthShellPath()) {
        return
    }
    redirectingToLogoutOn401 = true
    // Give the UI a moment to show the sign-in prompt before leaving.
    window.setTimeout(() => {
        window.location.assign("/application/logout")
    }, LOGOUT_REDIRECT_DELAY_MS)
}
